module.exports = __webpack_public_path__ + "img/my_off.c82e2eb1.png";